// src/utils/merchantCategoryOptions.js
import { addressCodeOptions } from './addressCodeOptions'

// ==================== 开户银行静态列表 ====================
export const personalBankList = [
    { account_bank: '建设银行', bank_alias: '建设银行', bank_alias_code: '1000009550', need_bank_branch: false },
    { account_bank: '工商银行', bank_alias: '工商银行', bank_alias_code: '1000009547', need_bank_branch: false },
    { account_bank: '农业银行', bank_alias: '农业银行', bank_alias_code: '1000009548', need_bank_branch: false },
    { account_bank: '中国银行', bank_alias: '中国银行', bank_alias_code: '1000009549', need_bank_branch: false },
    { account_bank: '招商银行', bank_alias: '招商银行', bank_alias_code: '1000009561', need_bank_branch: false },
    { account_bank: '交通银行', bank_alias: '交通银行', bank_alias_code: '1000009554', need_bank_branch: false },
    { account_bank: '民生银行', bank_alias: '民生银行', bank_alias_code: '1000009558', need_bank_branch: false },
    { account_bank: '中信银行', bank_alias: '中信银行', bank_alias_code: '1000009555', need_bank_branch: false },
    { account_bank: '浦发银行', bank_alias: '浦发银行', bank_alias_code: '1000009563', need_bank_branch: false },
    { account_bank: '兴业银行', bank_alias: '兴业银行', bank_alias_code: '1000009562', need_bank_branch: false },
    { account_bank: '光大银行', bank_alias: '光大银行', bank_alias_code: '1000009556', need_bank_branch: false },
    { account_bank: '广发银行', bank_alias: '广发银行', bank_alias_code: '1000009559', need_bank_branch: false },
    { account_bank: '平安银行', bank_alias: '平安银行', bank_alias_code: '1000009560', need_bank_branch: false },
    { account_bank: '华夏银行', bank_alias: '华夏银行', bank_alias_code: '1000009557', need_bank_branch: false },
    { account_bank: '邮政储蓄银行', bank_alias: '邮政储蓄银行', bank_alias_code: '1000009571', need_bank_branch: false },
    { account_bank: '上海银行', bank_alias: '上海银行', bank_alias_code: '1000009569', need_bank_branch: false },
    { account_bank: '宁波银行', bank_alias: '宁波银行', bank_alias_code: '1000005229', need_bank_branch: false },
    { account_bank: '南京银行', bank_alias: '南京银行', bank_alias_code: '1000005234', need_bank_branch: false },
    { account_bank: '其他银行', bank_alias: '北京银行', bank_alias_code: '1000009570', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '天津银行', bank_alias_code: '1000005213', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '沧州银行', bank_alias_code: '1000005207', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '河北银行', bank_alias_code: '1000005251', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '齐鲁银行', bank_alias_code: '1000005204', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '廊坊银行', bank_alias_code: '1000005186', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '邯郸银行', bank_alias_code: '1000005199', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '保定银行', bank_alias_code: '1000005290', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '唐山银行', bank_alias_code: '1000005240', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '张家口银行', bank_alias_code: '1000005248', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '承德银行', bank_alias_code: '1000005265', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '邢台银行', bank_alias_code: '1000005192', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '秦皇岛银行', bank_alias_code: '1000005215', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '衡水银行', bank_alias_code: '1000005246', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '郑州银行', bank_alias_code: '1000005274', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '中原银行', bank_alias_code: '1000005272', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '洛阳银行', bank_alias_code: '1000005271', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '西安银行', bank_alias_code: '1000005241', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '长安银行', bank_alias_code: '1000005261', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '兰州银行', bank_alias_code: '1000005287', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '甘肃银行', bank_alias_code: '1000005205', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '盛京银行', bank_alias_code: '1000005250', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '大连银行', bank_alias_code: '1000005304', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '锦州银行', bank_alias_code: '1000005317', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '吉林银行', bank_alias_code: '1000005228', need_bank_branch: true },
    { account_bank: '其他银行', bank_alias: '哈尔滨银行', bank_alias_code: '1000005255', need_bank_branch: true }
]

// ==================== 经营类目配置 ====================
export const fullCategoryOptions = [
    { id: '1', name: '餐饮', children: [
            { id: '101', name: '餐厅' }, { id: '102', name: '快餐' }, { id: '103', name: '火锅' },
            { id: '104', name: '烧烤' }, { id: '105', name: '小吃' }, { id: '106', name: '咖啡厅' },
            { id: '107', name: '茶馆' }, { id: '108', name: '酒吧' }, { id: '109', name: '外卖平台' },
            { id: '110', name: '其他餐饮' }
        ]},
    { id: '2', name: '食品/饮料/烟酒', children: [
            { id: '201', name: '食品零售' }, { id: '202', name: '饮料/饮用水' }, { id: '203', name: '烟酒专卖' },
            { id: '204', name: '茶叶专卖' }, { id: '205', name: '休闲食品' }, { id: '206', name: '保健食品' },
            { id: '207', name: '生鲜/水果' }, { id: '208', name: '粮油/调味品' }, { id: '209', name: '其他食品' }
        ]},
    { id: '3', name: '综合零售', children: [
            { id: '301', name: '超市' }, { id: '302', name: '便利店' }, { id: '303', name: '百货商场' },
            { id: '304', name: '购物中心' }, { id: '305', name: '免税店' }, { id: '306', name: '自动售货机' },
            { id: '307', name: '其他综合零售' }
        ]},
    { id: '4', name: '服装/纺织/皮具', children: [
            { id: '401', name: '服装鞋帽' }, { id: '402', name: '箱包皮具' }, { id: '403', name: '珠宝首饰' },
            { id: '404', name: '钟表眼镜' }, { id: '405', name: '纺织品' }, { id: '406', name: '其他服饰' }
        ]},
    { id: '5', name: '数码家电/办公用品', children: [
            { id: '501', name: '手机/通讯设备' }, { id: '502', name: '电脑/办公设备' }, { id: '503', name: '家用电器' },
            { id: '504', name: '摄影器材' }, { id: '505', name: '数码配件' }, { id: '506', name: '办公用品' },
            { id: '507', name: '其他数码产品' }
        ]},
    { id: '6', name: '美妆/个护/家清', children: [
            { id: '601', name: '美容护肤' }, { id: '602', name: '彩妆' }, { id: '603', name: '个人护理' },
            { id: '604', name: '家庭清洁' }, { id: '605', name: '口腔护理' }, { id: '606', name: '其他美妆个护' }
        ]},
    { id: '7', name: '母婴/玩具乐器', children: [
            { id: '701', name: '母婴用品' }, { id: '702', name: '奶粉/辅食' }, { id: '703', name: '童装/童鞋' },
            { id: '704', name: '玩具' }, { id: '705', name: '乐器' }, { id: '706', name: '其他母婴产品' }
        ]},
    { id: '8', name: '家居家装/建材', children: [
            { id: '801', name: '家具' }, { id: '802', name: '家纺' }, { id: '803', name: '家居装饰' },
            { id: '804', name: '建材' }, { id: '805', name: '五金工具' }, { id: '806', name: '其他家装' }
        ]},
    { id: '9', name: '汽车/交通出行', children: [
            { id: '901', name: '汽车销售' }, { id: '902', name: '汽车用品/配件' }, { id: '903', name: '汽车维修/保养' },
            { id: '904', name: '汽车美容' }, { id: '905', name: '加油/充电' }, { id: '906', name: '停车' },
            { id: '907', name: '租车' }, { id: '908', name: '代驾' }, { id: '909', name: '公共交通' },
            { id: '910', name: '其他交通出行' }
        ]},
    { id: '10', name: '医疗健康', children: [
            { id: '1001', name: '综合医院' }, { id: '1002', name: '专科医院' }, { id: '1003', name: '诊所/门诊部' },
            { id: '1004', name: '社区卫生服务中心' }, { id: '1005', name: '体检中心' }, { id: '1006', name: '口腔/牙科' },
            { id: '1007', name: '眼科' }, { id: '1008', name: '美容整形' }, { id: '1009', name: '康复理疗' },
            { id: '1010', name: '中医' }, { id: '1011', name: '心理咨询' }, { id: '1012', name: '其他医疗服务' }
        ]},
    { id: '11', name: '药品/医疗器械', children: [
            { id: '1101', name: '药品零售/药店' }, { id: '1102', name: '中药饮片' }, { id: '1103', name: '医疗器械零售' },
            { id: '1104', name: '成人用品/计生' }, { id: '1105', name: '隐形眼镜/护理液' }, { id: '1106', name: '其他药品/器械' }
        ]},
    { id: '12', name: '教育培训', children: [
            { id: '1201', name: '学前教育' }, { id: '1202', name: '中小学教育' }, { id: '1203', name: '高等教育' },
            { id: '1204', name: '语言培训' }, { id: '1205', name: '职业技能培训' }, { id: '1206', name: '艺术培训' },
            { id: '1207', name: '体育培训' }, { id: '1208', name: '在线教育' }, { id: '1209', name: '其他教育培训' }
        ]},
    { id: '13', name: '文化娱乐/体育', children: [
            { id: '1301', name: '电影院' }, { id: '1302', name: '剧院/演出' }, { id: '1303', name: 'KTV' },
            { id: '1304', name: '网吧/电竞' }, { id: '1305', name: '游戏厅' }, { id: '1306', name: '游乐园/主题公园' },
            { id: '1307', name: '博物馆/展览馆' }, { id: '1308', name: '健身房' }, { id: '1309', name: '游泳馆' },
            { id: '1310', name: '球类运动' }, { id: '1311', name: '瑜伽/舞蹈' }, { id: '1312', name: '其他文体娱乐' }
        ]},
    { id: '14', name: '生活服务', children: [
            { id: '1401', name: '美容美发' }, { id: '1402', name: '美甲/美睫' }, { id: '1403', name: '洗衣/皮具护理' },
            { id: '1404', name: '家政服务' }, { id: '1405', name: '摄影/照相' }, { id: '1406', name: '婚庆服务' },
            { id: '1407', name: '殡葬服务' }, { id: '1408', name: '宠物服务' }, { id: '1409', name: '维修服务' },
            { id: '1410', name: '其他生活服务' }
        ]},
    { id: '15', name: '酒店/旅游', children: [
            { id: '1501', name: '酒店住宿' }, { id: '1502', name: '民宿/公寓' }, { id: '1503', name: '旅行社' },
            { id: '1504', name: '景区/景点' }, { id: '1505', name: '机票/车票代理' }, { id: '1506', name: '其他旅游服务' }
        ]},
    { id: '16', name: '房地产', children: [
            { id: '1601', name: '房地产开发' }, { id: '1602', name: '房产中介' }, { id: '1603', name: '物业管理' },
            { id: '1604', name: '装修/装饰' }, { id: '1605', name: '其他房地产' }
        ]},
    { id: '17', name: '金融/保险', children: [
            { id: '1701', name: '银行' }, { id: '1702', name: '保险' }, { id: '1703', name: '证券/基金' },
            { id: '1704', name: '信托/担保' }, { id: '1705', name: '小额贷款' }, { id: '1706', name: '典当' },
            { id: '1707', name: '其他金融服务' }
        ]},
    { id: '18', name: '通讯/IT/互联网', children: [
            { id: '1801', name: '电信运营商' }, { id: '1802', name: '软件开发' }, { id: '1803', name: '网站/平台运营' },
            { id: '1804', name: '云计算/大数据' }, { id: '1805', name: '互联网推广' }, { id: '1806', name: '其他IT服务' }
        ]},
    { id: '19', name: '物流/仓储', children: [
            { id: '1901', name: '快递/物流' }, { id: '1902', name: '货运/运输' }, { id: '1903', name: '仓储服务' },
            { id: '1904', name: '搬家服务' }, { id: '1905', name: '其他物流服务' }
        ]},
    { id: '20', name: '公共服务/缴费', children: [
            { id: '2001', name: '水费' }, { id: '2002', name: '电费' }, { id: '2003', name: '燃气费' },
            { id: '2004', name: '供暖费' }, { id: '2005', name: '物业费' }, { id: '2006', name: '交通罚款' },
            { id: '2007', name: '话费充值' }, { id: '2008', name: '有线电视' }, { id: '2009', name: '其他公共事业' }
        ]},
    { id: '21', name: '政府/社会组织', children: [
            { id: '2101', name: '政府机关' }, { id: '2102', name: '事业单位' }, { id: '2103', name: '社会团体' },
            { id: '2104', name: '慈善组织' }, { id: '2105', name: '宗教组织' }, { id: '2106', name: '其他组织' }
        ]},
    { id: '22', name: '农业/牧业/渔业', children: [
            { id: '2201', name: '农产品销售' }, { id: '2202', name: '农资/农机' }, { id: '2203', name: '畜牧/养殖' },
            { id: '2204', name: '渔业/水产' }, { id: '2205', name: '其他农业' }
        ]},
    { id: '23', name: '其他行业', children: [
            { id: '2301', name: '广告/传媒' }, { id: '2302', name: '咨询/服务' }, { id: '2303', name: '法律服务' },
            { id: '2304', name: '人力资源' }, { id: '2305', name: '租赁服务' }, { id: '2306', name: '二手交易' },
            { id: '2307', name: '收藏/艺术品' }, { id: '2308', name: '宠物/花鸟' }, { id: '2309', name: '其他未分类' }
        ]}
]

// ==================== 主体类型 ====================
export const subjectTypeMap = { INDIVIDUAL: 'SUBJECT_TYPE_INDIVIDUAL', ENTERPRISE: 'SUBJECT_TYPE_ENTERPRISE', GOVERNMENT: 'SUBJECT_TYPE_GOVERNMENT', INSTITUTIONS: 'SUBJECT_TYPE_INSTITUTIONS', OTHERS: 'SUBJECT_TYPE_OTHERS' }
export const subjectTypeOptions = [ { label: '个体工商户', value: 'INDIVIDUAL' }, { label: '企业', value: 'ENTERPRISE' }, { label: '政府机关', value: 'GOVERNMENT' }, { label: '事业单位', value: 'INSTITUTIONS' }, { label: '其他组织', value: 'OTHERS' } ]

// ==================== 经营场景 ====================
export const salesSceneMap = { STORE: 'SALES_SCENES_STORE', MINI_PROGRAM: 'SALES_SCENES_MINI_PROGRAM', MP: 'SALES_SCENES_MP', APP: 'SALES_SCENES_APP', WEB: 'SALES_SCENES_WEB' }
export const salesSceneOptions = [ { label: '线下门店', value: 'STORE' }, { label: '公众号', value: 'MP' }, { label: '小程序', value: 'MINI_PROGRAM' }, { label: 'APP', value: 'APP' }, { label: '网站', value: 'WEB' } ]

// ==================== 账户类型 ====================
export const accountTypeMap = { CORPORATE: 'BANK_ACCOUNT_TYPE_CORPORATE', PERSONAL: 'BANK_ACCOUNT_TYPE_PERSONAL' }
export const accountTypeOptions = [ { label: '企业对公账户', value: 'CORPORATE' }, { label: '个人银行账户', value: 'PERSONAL' } ]
export const accountPlaceholderMap = { CORPORATE: '企业名称（与营业执照一致）', PERSONAL: '经营者姓名（与证件一致）' }

// ==================== 管理员类型 ====================
export const adminTypeOptions = [ { label: '法人/经营者', value: 'LEGAL' }, { label: '授权经办人', value: 'AGENT' } ]

// ==================== 结算规则ID选项 ====================
export const settlementOptions = [
    { label: '719 - 个体户 0.6%（餐饮/零售/药店等）', value: '719' }, { label: '716 - 企业 0.6%（餐饮/零售/药店等）', value: '716' },
    { label: '721 - 个体户 0.3%（快递/物流/加油）', value: '721' }, { label: '790 - 个体户 0.2%（民生缴费）', value: '790' },
    { label: '717 - 企业 0.3%（物流/快递/教育）', value: '717' }, { label: '730 - 企业 0.2%（民生缴费）', value: '730' },
    { label: '903 - 个体户 0.6%（服饰/美妆/健身）', value: '903' }, { label: '904 - 企业 0.6%（服饰/美妆/健身）', value: '904' }
]

// ==================== 图片用途映射 ====================
export const uploadPurposeMap = {
    businessLicense: 'business_license_copy', individualLicense: 'business_license_copy', idCardFront: 'id_card_copy',
    idCardBack: 'id_card_national', storeEntrance: 'store_entrance_pic', storeInterior: 'indoor_pic',
    miniProgram: 'mini_program_pics', mp: 'mini_program_pics', app: 'mini_program_pics', web: 'mini_program_pics',
    qualification: 'business_addition_pics', authorization: 'business_authorization_letter'
}

// ==================== 进度条颜色 ====================
export const progressColors = [
    { color: '#f56c6c', percentage: 20 }, { color: '#e6a23c', percentage: 40 },
    { color: '#5cb87a', percentage: 60 }, { color: '#1989fa', percentage: 80 }, { color: '#6f7ad3', percentage: 100 }
]

// ==================== 进件状态 ====================
export const applyStatusMap = { 1: '草稿', 2: '已提交', 3: '审核中', 4: '已通过', 5: '已驳回', 6: '已撤销' }
export const applyStatusTypeMap = { 1: 'info', 2: 'warning', 3: 'warning', 4: 'success', 5: 'error', 6: 'info' }

// ==================== 默认值 ====================
export const defaultSettlementId = '719'
export const defaultCategoryName = '保健器械/医疗器械/非处方药品'

// ==================== 不需要支行信息的银行 ====================
export const noBranchBanks = [
    '工商银行', '农业银行', '中国银行', '建设银行', '交通银行', '招商银行', '民生银行', '中信银行',
    '浦发银行', '兴业银行', '光大银行', '广发银行', '平安银行', '华夏银行', '邮政储蓄银行',
    '上海银行', '宁波银行', '南京银行'
]

// ==================== 开户银行卡号规则 ====================
export const bankCardRules = {
    '建设银行': { personal: [16,17,18,19,20], corporate: [16,19,20,21,24,25,26,27] },
    '工商银行': { personal: [16,17,18,19], corporate: [16,19,23,26,29] },
    '农业银行': { personal: [16,17,18,19], corporate: [15,17,18,19,27,28] },
    '中国银行': { personal: [12,16,18,19], corporate: [12,13,15,16,17,18,19,20] },
    '招商银行': { personal: [10,12,15,16], corporate: [13,15,16,17,18,19,20,21,25] },
    '交通银行': { personal: [16,17,18,19,21], corporate: [8,18,20,21,24,27] },
    '民生银行': { personal: [12,16,18,19], corporate: [9,15,16,20,22,23,24] },
    '中信银行': { personal: [16,19], corporate: [16,19] },
    '浦发银行': { personal: [12,16,19], corporate: [13,14,15,16,17,18,19,20,23] },
    '兴业银行': { personal: [16,18], corporate: [17,18,20,22,24] },
    '光大银行': { personal: [16,17], corporate: [17,21,22,23,24,25,26,27,28,29,30] },
    '广发银行': { personal: [16,18,19], corporate: [15,16,17,18,19,23,24] },
    '平安银行': { personal: [11,13,14,16,19], corporate: [13,14,18,19] },
    '华夏银行': { personal: [16], corporate: [16,17,22] },
    '邮政储蓄银行': { personal: [14,18,19], corporate: [16,18,23,24,27,28] }
}

export function validateBankCard(bankName, accountNumber, accountType) {
    const rule = bankCardRules[bankName]
    if (!rule) return true
    const lengths = accountType === 'CORPORATE' ? rule.corporate : rule.personal
    return lengths.includes(accountNumber.length)
}

// ==================== 微信行业映射 ====================
export const settlement719Industries = { "餐饮": 1, "零售": 3, "居民生活服务": 18, "保健器械/医疗器械/非处方药品": 34 }
export const categoryIdToWechatIndustry = { '1': '餐饮', '3': '零售', '11': '保健器械/医疗器械/非处方药品', '14': '居民生活服务' }

export function getWechatQualificationType(categoryIds, settlementId) {
    if (!categoryIds || categoryIds.length === 0) return defaultCategoryName
    return categoryIdToWechatIndustry[categoryIds[0]] || defaultCategoryName
}

// ==================== 重新导出地址编码 ====================
export { addressCodeOptions }

// ==================== 默认导出 ====================
export default {
    fullCategoryOptions, subjectTypeMap, subjectTypeOptions, salesSceneMap, salesSceneOptions,
    accountTypeMap, accountTypeOptions, accountPlaceholderMap, adminTypeOptions,
    settlementOptions, uploadPurposeMap, progressColors, applyStatusMap, applyStatusTypeMap,
    defaultSettlementId, defaultCategoryName, noBranchBanks, personalBankList,
    bankCardRules, validateBankCard, addressCodeOptions, getWechatQualificationType
}